import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=5810cbe2"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"
import style0 from "./CreateForm.vue?vue&type=style&index=0&id=5810cbe2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports